<template>
  <div id="totalizadores-mapa-financeiro" class="w3-border" style="margin: 0 8px">
    <div class="w3-card w3-theme">
      <strong>Saldo Inicial (Total):</strong> R$ {{ formatarValor(dados.total_saldos, 2) }}
    </div><!-- w3-card -->

    <div class="w3-panel w3-gray w3-text-white">
      <h6><strong>Contas a receber</strong></h6>
    </div>

    <div class="w3-card">
      <strong>Total de contas a receber:</strong> R$ {{ formatarValor(dados.total_contas_receber, 2) }}
    </div><!-- w3-card -->

    <div class="w3-card ">
      <strong>Total de previsões de venda:</strong> R$ {{ formatarValor(dados.total_previsoes_venda, 2) }}
    </div><!-- w3-card -->

    <div class="w3-card">
      <strong>Total a receber:</strong> R$ {{ formatarValor(dados.total_receber, 2) }}
    </div><!-- w3-card -->

    <div class="w3-panel w3-gray w3-text-white">
      <h6><strong>Contas a pagar</strong></h6>
    </div>

    <div class="w3-card ">
      <strong>Total de contas a pagar:</strong> R$ {{ formatarValor(dados.total_contas_pagar, 2) }}
    </div><!-- w3-card -->

    <div class="w3-panel w3-gray w3-text-white">
      <h6><strong>Previsões a pagar</strong></h6>
    </div>

    <div class="w3-card">
      <strong>Total de previsões a pagar:</strong> R$ {{ formatarValor(dados.total_previsoes_pagar, 2) }}
    </div><!-- w3-card -->

    <div class="w3-card ">
      <strong>Total a pagar:</strong> R$ {{ formatarValor(dados.total_contas_pagar + dados.total_previsoes_pagar, 2) }}
    </div><!-- w3-card -->

    <div class="w3-panel w3-gray w3-text-white">
      <h6><strong>Totais</strong></h6>
    </div>

    <div class="w3-card">
      <strong>Total realizado:</strong> R$ {{ formatarValor(dados.total_realizado, 2) }}
    </div><!-- w3-card -->

    <div class="w3-card ">
      <strong>Total previsto:</strong> R$ {{ formatarValor(dados.total_previsto, 2) }}
    </div><!-- w3-card -->

    <div class="w3-card">
      <strong>Total realizado + previsto:</strong> R$ {{ formatarValor(dados.total_realizado_previsto, 2) }}
    </div><!-- w3-card -->

    <div class="w3-card w3-theme">
      <strong>Saldo final:</strong> R$ {{ formatarValor(dados.saldo_final, 2) }}
    </div><!-- w3-card -->

  </div><!-- analitico-modelo-dois -->
</template>

<script>
import formatarValorMixin from '@/mixins/formatarValorMixin.js'
export default {
  name: 'TotalizadoresMapaFinanceiro',
  props: ['dados'],
  mixins:[formatarValorMixin],
  data() {  
    return {
      api: 'Arroz'
    }
  },
  mounted() {
    $('html,body').stop().animate({
      scrollTop: 0
    }, 'slow', 'swing');
  },
}
</script>

<style scoped>
  .chip-vencimento {
    border-radius: 25px;
    cursor: pointer;
    font-size: .9em;
    padding: 10px 15px;
    text-decoration: underline;
  }

  .w3-card {
    padding: 10px;
    box-shadow: none !important;
  }


  .card-box {
    border-left: 3px solid #9c1d1c;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 ;
    padding: 5px 10px;
  }

  .card-box .w3-text-theme {
    text-transform: uppercase;
  }

  .contas-card {
    text-transform: capitalize
  }

  .w3-panel {
    margin: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/TotalizadoresMapaFinanceiro.vue